/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.ApiResponse,
  CreateAutoBalanceTransfer: (params: vp.CreateAutoBalanceTransferRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostCreateAutoBalanceTransfer: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldCreateAutoBalanceTransfer, setShouldCreateAutoBalanceTransfer] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.CreateAutoBalanceTransferRequest>({
    ScheduleStartDate: '',
    AutoBalanceTransferAmount: 0,
    TypeOfFrequency: '',
  });
  const [response, setResponse] = useState<vp.ApiResponse>({
    Success: false,
    ErrorMessage: '',
  });

  useEffect(() => {
    if (!shouldCreateAutoBalanceTransfer) return () => {};

    const PostCreateAutoBalanceTransfer = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.postCreateAutoBalanceTransfer(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldCreateAutoBalanceTransfer) void PostCreateAutoBalanceTransfer();
    setShouldCreateAutoBalanceTransfer(false);
    return () => {
      source.cancel();
    };
  }, [shouldCreateAutoBalanceTransfer]);

  return [
    response,
    (_params: vp.CreateAutoBalanceTransferRequest) => {
      setParams(_params);
      setShouldCreateAutoBalanceTransfer(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setShouldCreateAutoBalanceTransfer(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostCreateAutoBalanceTransfer);
